<template>
  <div class="course">
    <div class="breadcrumb">
      <span>{{currentCourse.name}}</span>
    </div>
    <p class="tip-line">{{currentCourse.describe}}</p>
    <el-badge :value="wrongNumber" class="wrong-book">
      <el-button size="small" @click="openWrongBook">错题本</el-button>
    </el-badge>
    <el-row :gutter="10">
      <el-col :span="8">
        <p class="title">选择单元</p>
        <div class="data-list unit">
          <ul>
            <li
                v-for="unit in unitList"
                :key="unit.id"
                :class="{selected: currentUnitId === unit.id}"
                @click="selectUnit(unit)"
            >
              <p class="unit-name" :title="unit.name" :id="unit.id">
                <span class="unit-name__inner">{{ unit.name }}</span>
                <el-tag v-if="unit.isExperience" size="mini">快速体检</el-tag>
              </p>
              <span
                  class="status"
                  :class="{
                    finished: unit.status === 1,
                    underway: unit.status === 2,
                  }"
              >
                <template v-if="currentCourse.type === 'YW'">
                  <template v-if="unit.status === 0">未完成</template>
                  <template v-else-if="unit.status === 1">已完成</template>
                  <template v-else>进行中</template>
                </template>
                <template v-else>
                  <template v-if="unit.status === 0">未完成</template>
                  <template v-else-if="unit.status === 3">已达标</template>
                  <template v-else>{{unit.progress}}%</template>
                </template>
              </span>
            </li>
          </ul>
        </div>
      </el-col>
      <el-col :span="16">
        <p class="title">{{currentUnit.name}}</p>
        <div class="data-list module">
          <ul v-if="practiceList.length">
            <li
                v-for="module in practiceList"
                :key="module.id"
            >
              <p class="module-name">{{ module.name }}</p>
              <div class="operation">
                <el-button :type="module.view.isFinished ? 'primary' : 'info'"
                           size="mini"
                           plain
                           round
                           @click="startPlay(module.view, 'view')"
                >
                  开始学习
                </el-button>
                <!-- <el-button :type="module.review.isFinished ? 'primary' : 'info'"
                           size="mini"
                           plain
                           round
                           @click="startPlay(module.review, 'review')"
                >
                  复习
                </el-button> -->
              </div>
            </li>
          </ul>
          <p class="empty" v-else>暂无数据</p>
        </div>
      </el-col>
    </el-row>
    <van-c-n-dialog
        ref="cn-dialog"
        :navigation="quizData.navigation"
        :title="quizData.title"
        :subtitle="quizData.subtitle"
        :description="quizData.description"
        :type="quizData.type"
        :learn-mode="learnMode"
        :status="quizData.status"
        :play-times="quizData.playTimes"
        :quizzes="quizzes"
        :project-code="currentCourse.projectCode"
        @submit="submitQuizResult"
        @continue="handleContinue"
        @refresh="getUnitList"
    />
  </div>
</template>

<script>
import {
  Row,
  Col,
  Button,
  Badge,
  Tag,
} from 'element-ui';
import audioPlayer from 'vanthink-components/utils/audio-player';
import VanCNDialog from '@/components/quizzes/chinese/Dialog.vue';
import utils from '@/services/utils';
import api from '@/api/graphql/chineseCourse';

export default {
  components: {
    ElRow: Row,
    ElCol: Col,
    ElButton: Button,
    ElBadge: Badge,
    ElTag: Tag,
    VanCNDialog,
  },
  data() {
    return {
      currentUnitId: 0,
      unitList: [],
      modules: {}, // class array
      quizData: {},
      learnMode: '',
      currentCourse: {},
      wrongNumber: 0,
    };
  },
  watch: {
    $route() {
      // reset current unitId id
      this.currentUnitId = 0;
    },
    currentCourse() {
      this.getUnitList();
    },
  },
  computed: {
    courseId() {
      return Number(this.$route.params.courseId || 0);
    },
    practiceList() {
      return this.modules[this.currentUnitId] || [];
    },
    currentUnit() {
      return utils.Array.find(this.unitList, { id: this.currentUnitId }, 'id') || {};
    },
    quizzes() {
      if (this.quizData.quizzes) {
        // 冻结对象
        return this.quizData.quizzes.map(quiz => Object.freeze(quiz));
      }
      return [];
    },
  },
  methods: {
    selectUnit({ id }) {
      this.getModuleList(id);
    },
    startPlay({ id, isFinished, isCompleted }, type) {
      this.learnMode = type;
      if (!isFinished) {
        if (type === 'view') {
          utils.error('请先完成上一篇文章的“新学”');
        } else {
          utils.error('请先完成本篇文章的“新学”');
        }
        return;
      }
      this.getQuizData({
        moduleId: id,
        isCompleted,
        type,
      }, 'cn-dialog');
    },
    getUnitList() {
      if (!this.currentCourse.type) return;
      api.getCourseUnitList({
        courseId: this.courseId,
        type: this.currentCourse.type,
      })
        .then(({ chineseCourseUnitList }) => {
          this.unitList = [
            ...chineseCourseUnitList.list.filter(item => item.isExperience),
            ...chineseCourseUnitList.list.filter(item => !item.isExperience),
          ];
          this.wrongNumber = chineseCourseUnitList.wrongNumber;
          const firstUnit = utils.Array.find(this.unitList, { status: 2 }, 'status')
            || utils.Array.find(this.unitList, { status: 0 }, 'status')
            || utils.Array.find(this.unitList, { status: 1 }, 'status');
          if (!this.currentUnitId) {
            this.currentUnitId = firstUnit.id;
          }
          this.getModuleList(this.currentUnitId || firstUnit.id);
        });
    },
    getModuleList(unitId) {
      const container = document.querySelector('.module');
      const loadingInstance = utils.loading(container);
      api.getCourseModulelList({
        unitId,
      })
        .then(({ chineseCourseModuleList }) => {
          this.currentUnitId = unitId;
          if (loadingInstance) {
            loadingInstance.close();
          }
          const moduleList = chineseCourseModuleList.map((item) => {
            const { name, modeList } = item;
            const [view, review] = modeList;
            return {
              id: view.id,
              name,
              view,
              review,
            };
          });
          this.$set(this.modules, unitId, moduleList);
        })
        .catch((error) => {
          if (error && error.code === 1033) {
            utils.alert(`<div style="white-space: pre-line;">${error.message}</div>`, '体验结束', {
              dangerouslyUseHTMLString: true,
              confirmButtonText: '知道了',
              center: true,
            });
          } else {
            utils.error(error.message);
          }

          if (loadingInstance) {
            loadingInstance.close();
          }
        });
    },
    getQuizData(
      {
        moduleId,
        type,
        courseId,
        unitId,
        mode,
        examType,
        examMode,
        callback,
        isCompleted,
      },
      dialog,
    ) {
      return new Promise((resolve, reject) => {
        api.getCourseData({
          modelId: moduleId,
          type,
          courseId,
          unitId,
          mode,
          examType,
          examMode,
          projectCode: this.currentCourse.projectCode,
        })
          .then(({ chineseCourseData }) => {
            chineseCourseData.moduleId = moduleId;
            this.quizData = chineseCourseData;
            // 微课单独处理 模块完成标记微课已经完成 可拖拽进度
            this.quizData.quizzes.forEach((quiz) => {
              if (quiz.code === 'WK') {
                quiz.isCompleted = isCompleted;
              }
            });

            const audios = this.quizData.quizzes.filter(quiz => quiz.audio);
            audioPlayer.preload(audios.map(quiz => quiz.audio));

            const { message } = chineseCourseData;
            if (!chineseCourseData.quizzes.length && type === 'force') return;
            if (message) {
              utils.alert(message, '提示', {
                confirmButtonText: '知道了',
                showClose: false,
              })
                .then(() => {
                  this.$refs[dialog].open();
                });
            } else {
              this.$refs[dialog].open();
            }
            if (callback) {
              callback();
            }
            resolve();
          }, (e) => {
            reject(e);
          });
      });
    },
    submitQuizResult({
      data,
      seconds,
      callback,
      type,
      mode,
    }) {
      api.submitCourseResult({
        id: this.quizData.id,
        moduleId: this.quizData.moduleId,
        quizzes: data,
        type,
        seconds,
        mode,
      })
        .then(({ chineseCourseResult }) => {
          if (callback) {
            callback(chineseCourseResult);
          }
        }, (e) => {
          this.$refs['cn-dialog'].error(e);
        });
    },
    handleContinue(type, scene) {
      const dialog = 'cn-dialog';
      const params = {
        moduleId: this.quizData.moduleId,
        type: type || this.quizData.type,
      };
      this.getQuizData(params, dialog)
        .then(() => {
          if (this.quizData.type === 'test') {
            this.$refs[dialog].scene = scene || 1;
          } else {
            this.$refs[dialog].scene = scene || 2;
          }
        }, (e) => {
          this.$refs['cn-dialog'].error(e);
        });
    },
    forcePush() {
      this.getQuizData({
        courseId: this.courseId,
        type: 'force',
      }, 'cn-dialog');
    },
    openWrongBook() {
      this.getQuizData({
        courseId: this.courseId,
        type: 'wrong',
      }, 'cn-dialog');
    },
  },
  created() {
    this.getUnitList();
    this.forcePush();
  },
  beforeRouteEnter(to, from, next) {
    const bookInfo = utils.storage('bookInfo');
    if (bookInfo) {
      next((vm) => {
        vm.currentCourse = bookInfo;
      });
    } else {
      next({
        path: '/learning-center/elective',
        replace: true,
      });
    }
  },
};
</script>

<style lang="scss" scoped>
  @import '@/styles/variables.scss';
  @import '@/styles/common/tip-line.scss';

  .course {
    position: relative;
    .bdc-btn {
      margin: 0 20px 0;
      .el-button {
        margin-bottom: 20px;
        margin-left: 0;
        width: 155px;
      }
    }
    .el-row {
      box-sizing: border-box;
      height: 82%;
      padding: 20px;
      .el-col {
        height: 100%;
      }
    }
    .title {
      height: 40px;
      line-height: 40px;
      background-color: $primary;
      margin: 0;
      padding-left: 10px;
      color: #fff;
      border-radius: 5px 5px 0 0;
    }
    .wrong-book {
      position: absolute;
      right: 20px;
      top: 10px;
    }
    .data-list {
      box-sizing: border-box;
      height: 100%;
      border: 1px solid $primary;
      border-radius: 0 0 5px 5px;
      overflow-y: auto;
      .empty {
        text-align: center;
      }
      ul {
        li {
          position: relative;
          height: 35px;
          line-height: 35px;
          padding: 0 12px;
          cursor: pointer;
          p {
            margin: 0;
          }
        }
      }
      &.unit {
        ul {
          li {
            .unit-name {
              margin: 0;
              padding-right: 60px;
              .unit-name__inner {
                display: inline-block;
                max-width: 200px;
                padding-right: 10px;
                vertical-align: middle;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
            }
            .status {
              position: absolute;
              right: 12px;
              top: 0;
              &.finished {
                color: $success;
              }
              &.underway {
                color: $primary;
              }
            }
            &:hover {
              background-color: rgba($primary, .2);
            }
            &.selected {
              background-color: rgba($primary, .2);
              font-weight: bold;
            }
          }
        }
      }
      &.module {
        position: relative;
        ul {
          li {
            box-sizing: border-box;
            border-bottom: 1px solid #eee;
            height: 45px;
            line-height: 45px;
            .module-name {
              margin: 0;
              padding-right: 140px;
            }
            .operation {
              position: absolute;
              right: 10px;
              top: 0;
            }
            &.active {
              color: red;
            }
          }
        }
      }
    }
  }
</style>
